import {Pipe, PipeTransform} from '@angular/core';
import {KeyValuePipe} from '@angular/common';
import {orderBy} from 'lodash-es';

@Pipe({
  name: 'sortedKeyValue'
})
export class SortedKeyValuePipe extends KeyValuePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    const values = super.transform(value);
    if (args) {
      return orderBy(values, `value.${args}`);
    }
    return values;
  }

}
